import { LocalStorageKeys } from "../local-storage-keys"
import { getlangFromCache } from ".."
import { IRawSupplierReference, ISupplierReference } from "../../models"
import { IDropdownOption } from "../../ui/product-form/_reducers/_utils/product-form-types"

export * from "./arrays"
export * from "./integer"
export * from "./string"

export interface ICreateControlProps {
  controls: Array<
    | ((value: any, options?: IDropdownOption[]) => boolean)
    | ((value: any) => boolean)
  >
  errorMessage: string
  localized: boolean
  options?: IDropdownOption[]
}

const createControl =
  ({ controls, errorMessage, localized, options }: ICreateControlProps) =>
  (value: any) => {
    if (!localized) {
      return controls.every((control) => control(value, options))
        ? ""
        : errorMessage
    } else {
      const temp = value
        .filter((v: any) => v.value !== "" || v.lang === getlangFromCache())
        .map((v: any) =>
          controls.every((control) => control(v.value, options))
            ? ""
            : errorMessage
        )

      return temp.find((v: any) => v !== "") || ""
    }
  }

// export const controlMultilang = (
//   control: (value: any) => string,
//   values: object,
//   activeLang: string
// ) => {
//   return Object.keys(values).reduce((accumulator: any, key) => {
//     if (key !== activeLang && values[key] === "") {
//       accumulator[key] = ""
//     } else {
//       accumulator[key] = control(values[key])
//     }

//     return accumulator
//   }, {})
// }

export const isError = (error: any) => {
  if (!error) {
    return false
  }
  return error !== ""
}

export default createControl

export const preventExistingIdReferenceCreation = (
  refList: IRawSupplierReference[],
  ean: string,
  supplierRef: string,
  formId: string
) => {
  let prevent = false
  refList.forEach((r) => {
    if (String(r.droopyId) !== String(formId)) {
      if (r.supplierRef === supplierRef) {
        prevent = true
      }
      if (ean && r.ean === ean) {
        prevent = true
      }
    }
  })
  return prevent
}
